import App from "@/components/survey";
import type { GetServerSideProps, GetServerSidePropsContext } from "next";
import { generateSurveyData } from "@/redux/features/survey/slice";
import { setPageData } from "@/redux/features/visits-logging/slice";
import { wrapper } from "@/redux/store/store";
import {
  fetchSurvey,
  fetchSurveyPage,
  fetchSurveyResponses
} from "@/redux/features/survey/thunk";
import { withCommonData } from "@/hocs/with-common-data";
import { withParticipantData } from "@/hocs/with-participant-data";
import type { ReactElement } from "react";
import { withProjectAccess } from "@/hocs/with-project-access";
import { withUserSession } from "@/hocs/with-user-session";
import { setPageData as setToolData } from "@/redux/features/user/slice";
import EmbedsLayout from "@/components/shared/layouts/embeds/default";
import { SingleColumnLayout } from "@/storybook-components";

export default function Page() {
  return <App />;
}

Page.getLayout = function getLayout(page: ReactElement) {
  return (
    <EmbedsLayout>
      <SingleColumnLayout
        colStart={{ base: 1, lg: 1, xl: 4, "2xl": 4 }}
        colSpan={{ base: 4, lg: 12, xl: 6, "2xl": 6 }}
        padding={{ sm: "2.5rem 0" }}
      >
        {page}
      </SingleColumnLayout>
    </EmbedsLayout>
  );
};

export const getServerSideProps: GetServerSideProps = withCommonData(
  withParticipantData(
    withUserSession(
      withProjectAccess(
        wrapper.getServerSideProps(
          (store) => async (ctx: GetServerSidePropsContext) => {
            const config = {
              headers: {
                cookie: ctx?.req?.headers?.cookie
              }
            };
            await store.dispatch(fetchSurvey({ ...ctx.query, config }));
            await store.dispatch(fetchSurveyPage({ ...ctx.query, config }));

            if (store.getState().user.registeredUser?.isLoggedIn) {
              await store.dispatch(
                fetchSurveyResponses({ ...ctx.query, config })
              );
            }

            store.dispatch(
              setToolData({
                toolId: ctx.query?.surveyId,
                toolType: "SurveyTool"
              })
            );
            if (store.getState()?.survey?.survey?.id) {
              store.dispatch(
                setPageData({
                  itemId: store.getState().survey.survey.id,
                  itemType: "survey_tool",
                  pageType: "Project",
                  pageId: store.getState().survey.survey.project.id
                })
              );
            }
            store.dispatch(generateSurveyData());

            return {
              props: {}
            };
          }
        )
      )
    )
  )
);
